export default "__VITE_ASSET__Cu6Eix65__"